// extracted by mini-css-extract-plugin
export default {"img":"Home_img__YxiJm","home":"Home_home__7fLsL"};